var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFraudProtected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fraud_protected_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 15 17",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fraud_protected_svg__st0{fill:#979797}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fraud_protected_svg__st0",
    d: "M14.5 3.8L7.8.4c-.1 0-.2-.1-.3-.1-.1 0-.2 0-.3.1L.5 3.8c-.2.1-.3.2-.3.4 0 4 .9 6.7 2.3 8.5 1.3 1.6 2.9 2.9 4.7 3.8.2.1.4.1.6 0 1.8-.9 3.4-2.2 4.7-3.8 1.4-1.9 2.3-4.5 2.3-8.5 0-.2-.1-.3-.3-.4zm-3 8.3c-1.1 1.4-2.5 2.5-4 3.3-1.5-.8-2.9-2-4-3.3-1.3-1.8-2-4.2-2-7.4l6-3.1 6.1 3.1c.1 2.6-.7 5.2-2.1 7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fraud_protected_svg__st0",
    d: "M4.9 8.5c-.3-.2-.7-.2-1 .1-.2.3-.1.7.1.9l2 1.6c.3.2.6.2.9-.1C8.3 9.6 9.6 8.2 11 6.8c.3-.3.3-.7 0-.9-.1-.1-.3-.2-.5-.2s-.3.1-.5.2C8.8 7.2 7.6 8.5 6.4 9.7L4.9 8.5z"
  })));
}
export default SvgFraudProtected;